const images = {
    logo: require('./logoIcon.svg').default,
    home: require('./homeIcon.svg').default,
    search: require('./searchIcon.svg').default,
    watch_later_list: require('./libraryIcon.svg').default,
    back: require('./backIcon.svg').default,
    forward: require('./forwardIcon.svg').default,
    clear: require('./clearIcon.svg').default,
    noPoster: require('./NoPoster.png'),
    female: require('./female.png'),
    male: require('./male.png'),
    orther: require('./orther.png'),
    not: require('./not.png'),
};

export default images;
